<template>
    <div class="is-vertical-center installationsContainer">
        <div>
            <h2 class="title">{{ $t("installation.your") }}</h2>

            <div
                    :key="installation['.key']"
                    v-for="installation in orderedInstallations"
                    class="installation"
            >
                <div
                        class="installationName"
                        @click="loadInstallation(installation['.key'])"
                >
                    {{ installation.name }}
                    {{
                    installation.zones !== undefined
                        ? "(" +
                        Object.keys(installation.zones).length +
                        " " +
                        $t("installation.zones") +
                        ")"
                        : ""
                    }}
                </div>
                <div class="installationLinks">
                    <a
                            @click="
              $router.push('/installations/' + installation['.key'] + '/edit')
            "
                    >
                        <img src="/home/images/buttons/btn_editar.png" icon="power"/>
                    </a>
                    <a @click="setInstallationPower(installation)">
                        <img
                                v-if="installation.power"
                                src="/home/images/buttons/btn_apagar_instalacion.png"
                                icon="power"
                        />
                        <img
                                v-else
                                src="/home/images/buttons/btn_apagar_instalacion_off.png"
                                icon="power"
                        />
                    </a>
                    &nbsp;&nbsp;
                </div>

                <div class="location">
          <span
          >{{ installation.location }},
            <font v-if="installation.weather"
            >{{
                parseFloat(installation.weather.current_weather.temperature).toFixed(
                    1
                )
                }}
              º</font
            ></span
          >
                    <span v-if="installation.weather">
            <img
                    class="weather-icon"
                    :src="
                '/home/images/weather/' +
                getIconFileName(installation.weather.current_weather.weathercode)
              "
            />
          </span>
                </div>
            </div>
            <!--      <button @click="wizard" class="addInstallation button button-rounded">-->
            <!--        <b-icon icon="plus"></b-icon>-->
            <!--      </button>-->
        </div>
    </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import weather from "@/mixins/weather";

export default {
    name: "installations-list",
    mixins: [weather],
    data() {
        return {};
    },
    computed: {
        ...mapState("installations", {
            installations: "list",
        }),

        orderedInstallations: function () {
            return [...this.installations].sort((a, b) =>
                a.name.localeCompare(b.name)
            );
        },
    },

    watch: {
        installations: function () {
            this.loadTemperatures();
        },
    },

    methods: {
        ...mapActions("installations", ["setInstallationsWeather", "setPower"]),
        loadTemperatures: function () {
            this.setInstallationsWeather().then(() => {
                this.$forceUpdate();
            });
        },

        loadInstallation: function (installationId) {
            this.$router.push("/installations/" + installationId);
        },

        wizard: function () {
            this.$router.push("/installations/new");
        },
        setInstallationPower: function (installation) {
            this.setPower({installation: installation, power: !installation.power});
        },
    },

    mounted() {
        this.loadTemperatures();
    },
};
</script>
<style lang="scss" scoped>
.title {
  margin: 3rem 0 5rem;
  color: white;
}

.installationsContainer {
  //height: 100%;
  background-image: url("/home/images/backgrounds/installations.jpg");
  background-position: center center;
  background-size: cover;
  min-height: 100vh;
}

.installationsContainer > div {
  width: 480px;
  max-width: 100%;
  margin: 0px auto;
  padding: 0 2rem;
}

.installation {
  padding: 1vw;
  border-radius: 15px;
  background-color: rgba(246, 244, 244, 0.91);
  margin: 0 auto;
  margin-bottom: 2vw;
  text-align: left;
}

.installationName {
  float: left;
  font-weight: bold;
  cursor: pointer;
}

.installationLinks {
  float: right;
  text-align: right;
  width: 30%;

  img {
    max-width: 50%;
  }
}

.location {
  clear: left;
  display: flex;
  align-items: center;

  span:first-child {
    flex: 75;
  }

  span:last-child {
    flex: 25;
  }
}

.button-rounded {
  height: 4em;
  width: 4em;
  border-radius: 50%;
}

.addInstallation {
  height: 5em;
  width: 5em;
  background-color: rgba(246, 244, 244, 0.91);
  margin-left: 2em;
  border: 1px solid transparent;
  margin-bottom: 2rem;

  .icon i::before {
    font-size: 2em;
  }
}

.weather-icon {
  width: 50px;
  height: 50px;
}
</style>
